module.exports = __webpack_public_path__ + "static/media/SarahSwitek_10_Questions_5.16e35a53.mp3";